import React, { FunctionComponent } from 'react'
import { GreenBtn } from 'Stories/Button/Button.stories'
import { ButtonsGroups } from '../styles'
import { CanceledProps } from './types'

export const Canceled: FunctionComponent<CanceledProps> = ({ t, onClose }) => (
  <ButtonsGroups>
    <GreenBtn color="white" onClick={onClose}>
      {t('influencer.closeBtn')}
    </GreenBtn>
  </ButtonsGroups>
)
